import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const MAX_LENGTH = 255;

export class TourPointValidators {
    static referentNumberValidator = (): ValidatorFn => {
        const allowedCharsRegex = /^[A-Za-z0-9äöüÄÖÜ _()\\/ -]+$/;
        const startEndRegex = /^[\\/]|[\\/]$/;

        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value as string | null;

            if (!value) { return null; }

            if (value.length > MAX_LENGTH) {
                return {
                    maxLengthExceeded: {
                        message: $localize`Booking exceed ${MAX_LENGTH} characters.`
                    }
                };
            }

            if (!allowedCharsRegex.test(value)) {
                return {
                    invalidCharacters: {
                        message: $localize`Allowed: - ( ) / _ \\ and spaces`
                    }
                };
            }

            if (startEndRegex.test(value)) {
                return {
                    invalidStartEnd: {
                        message: $localize`The format of Booking is invalid.`
                    }
                };
            }

            return null;
        };
    };
}
